module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-4-3b23377c6a97328294b461f6e39830aa.jpg";